export const blockIconsEditorModeEditOutline = (
	<span className='material-symbols-outlined'>mode_edit_outline</span>
);
